import type { RouteRecordRaw } from 'vue-router';

export const readingPlansRoute: RouteRecordRaw = {
  path: `/reading-plans`,
  name: 'ReadingPlans',
  component: () => import('@/modules/reading-plan/views/ReadingPlans.vue'),
  meta: {
    layout: 'main',
  },
};

export const readingPlanDetailRoute: RouteRecordRaw = {
  path: `/reading-plans/:id/detail`,
  name: 'ReadingPlanDetail',
  component: () => import('@/modules/reading-plan/views/ReadingPlanDetail.vue'),
  meta: {
    layout: 'main',
  },
};

export const readingPlanDayRoute: RouteRecordRaw = {
  path: `/reading-plans/:id/day/:dayIndex`,
  name: 'ReadingPlanDay',
  component: () => import('@/modules/reading-plan/views/ReadingPlanDay.vue'),
  meta: {
    layout: 'main',
  },
};
